import {Fragment, useMemo} from "react";
import {SchemaCell} from "../SchemaCell";
import './AssemblyMainFields.scss';

interface IProps {
  part: number[][];
  onBrickClick?: (row: number, column: number) => void;
  activeBrick?: number;
  completedBrick: number;
  startX: number;
  startY: number;
}
export const AssemblyMainField = ({part, onBrickClick, activeBrick, completedBrick, startX, startY}:IProps) => {

  const headersX = useMemo(() => {
    return Array.from({ length: 16 }, (_, i) => startX + i + 1);
  }, [startX]);

  const signs = ['figure4', 'figure3', 'figure2', 'figure1', 'figure0'];
  const bricks= ['brick4', 'brick3', 'brick2', 'brick1', 'brick0'];

  return (
    <div className='assembly-main-field'>
      <div></div>
      {headersX.map((x, index) => (<div key={`before_${index}`} className='assembly-main-field_col'>{x}</div>))}
      <div></div>

      {part.map((row, ri) => {
        let count = 1; 
        let prev = -1;
        const yLabel = startY + ri + 1;

         return (<Fragment key={`${ri}-fragment`}>
            <div className='assembly-main-field_row' key={ri}>{yLabel}</div>
            {row.map((cell, ci) => {
                count = (cell === prev) ? count + 1 : 1;
                prev = cell;
                const index = ri*16+ci;
                return <SchemaCell
                  sign={(completedBrick && (index <= completedBrick - 1)) ? bricks[cell] : signs[cell]}
                  count={count}
                  key={`${ri}_${ci}`}
                  onClick={() => {onBrickClick(ri, ci)}}
                  selected={activeBrick && (index <= activeBrick - 1)}
                  completed={completedBrick && (index <= completedBrick - 1)}
                />
              }
            )}
            <div className='assembly-main-field_row'>{yLabel}</div>
          </Fragment>)
        }
      )}

      <div></div>
      {headersX.map((x, index) => (<div key={`after_${index}`} className='assembly-main-field_col'>{x}</div>))}
      <div></div>

    </div>
  )
}
